(function () {
  function initPage(root) {
    if (!root || root.dataset.oolReady === 'true') return;

    var perPage = parseInt(root.dataset.perPage, 10) || 25;
    var maxTotal = parseInt(root.dataset.maxTotal, 10) || 50;
    var maxDisplayPages = parseInt(root.dataset.maxPages, 10) || Math.ceil(maxTotal / perPage);

    var grid = root.querySelector('[data-ool-grid]');
    var skeleton = root.querySelector('[data-ool-skeleton]');
    var emptyState = root.querySelector('[data-ool-empty]');
    var panel = root.querySelector('[data-ool-panel]');
    var pagination = root.querySelector('[data-ool-pagination]');
    if (!grid || !panel) return;

    var pagePath = root.dataset.pagePath || window.location.pathname;
    var sectionKey = root.dataset.sectionKey || 'only-one-left-grid';
    var source = root.dataset.source || 'all';

    function getDisplayPage() {
      var page = parseInt(new URLSearchParams(window.location.search).get('page'), 10)
        || parseInt(root.dataset.displayPage, 10)
        || 1;
      if (page < 1) page = 1;
      if (page > maxDisplayPages) page = maxDisplayPages;
      return page;
    }

    function getSlice(displayPage) {
      var skip = (displayPage - 1) * perPage;
      var take = Math.min(perPage, maxTotal - skip);
      return { skip: skip, take: Math.max(take, 0) };
    }

    function pageUrl(displayPage) {
      if (displayPage <= 1) return pagePath;
      return pagePath + '?page=' + displayPage;
    }

    var displayPage = getDisplayPage();
    var slice = getSlice(displayPage);
    var catalogPage = 1;
    var skippedSoFar = 0;
    var rendered = panel.querySelectorAll('[data-ool-product]').length;
    var loading = false;

    function refreshLazyImages() {
      if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
      }
    }

    function updatePagination(count) {
      if (!pagination) return;

      var prev = pagination.querySelector('[data-ool-prev]');
      var next = pagination.querySelector('[data-ool-next]');
      var label = pagination.querySelector('[data-ool-page-label]');

      if (label) {
        label.textContent = 'Page ' + displayPage + ' of ' + maxDisplayPages;
      }

      if (prev) {
        if (displayPage > 1) {
          prev.href = pageUrl(displayPage - 1);
          prev.hidden = false;
        } else {
          prev.hidden = true;
        }
      }

      if (next) {
        var hasNextPage = displayPage < maxDisplayPages
          && count >= perPage
          && (displayPage * perPage) < maxTotal;
        if (hasNextPage) {
          next.href = pageUrl(displayPage + 1);
          next.hidden = false;
        } else {
          next.hidden = true;
        }
      }

      pagination.hidden = count === 0 || (displayPage <= 1 && next && next.hidden);
    }

    function finishLoading(count) {
      root.classList.remove('is-ool-loading');
      root.dataset.oolReady = 'true';
      grid.removeAttribute('aria-busy');
      if (skeleton && skeleton.parentNode) {
        skeleton.parentNode.removeChild(skeleton);
      }
      refreshLazyImages();
      updatePagination(count);
    }

    function showEmpty() {
      finishLoading(0);
      if (emptyState) emptyState.hidden = false;
    }

    function appendChunk(html) {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();
      var items = wrapper.querySelectorAll('[data-ool-product]');
      items.forEach(function (item) {
        panel.appendChild(item);
      });
      return {
        rendered: items.length,
        meta: wrapper.querySelector('.ool-chunk-meta')
      };
    }

    function fetchCatalogChunk() {
      if (loading || slice.take <= 0) {
        showEmpty();
        return;
      }

      if (rendered >= slice.take) {
        finishLoading(rendered);
        return;
      }

      loading = true;
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var base = rootUrl.replace(/\/$/, '') + pagePath;
      var url = base
        + '?sections=' + encodeURIComponent(sectionKey)
        + '&page=' + catalogPage
        + '&ool_skip=' + slice.skip
        + '&ool_take=' + slice.take
        + '&ool_skipped=' + skippedSoFar
        + '&ool_source=' + encodeURIComponent(source);

      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('fetch failed');
          return res.json();
        })
        .then(function (data) {
          var html = data && data[sectionKey];
          if (!html) throw new Error('missing section');

          var result = appendChunk(html);
          rendered += result.rendered;

          var meta = result.meta;
          skippedSoFar = meta ? parseInt(meta.getAttribute('data-skipped'), 10) || skippedSoFar : skippedSoFar;
          var catalogHasMore = meta && meta.getAttribute('data-catalog-has-more') === 'true';
          var catalogNext = meta ? parseInt(meta.getAttribute('data-catalog-next-page'), 10) : catalogPage + 1;

          loading = false;

          if (rendered >= slice.take || !catalogHasMore) {
            if (rendered === 0) showEmpty();
            else finishLoading(rendered);
            return;
          }

          catalogPage = catalogNext || catalogPage + 1;
          fetchCatalogChunk();
        })
        .catch(function () {
          loading = false;
          if (rendered === 0) showEmpty();
          else finishLoading(rendered);
        });
    }

    if (rendered >= slice.take && rendered > 0) {
      finishLoading(rendered);
      return;
    }

    if (rendered > 0 && rendered < slice.take) {
      var meta = panel.querySelector('.ool-chunk-meta');
      if (meta) {
        skippedSoFar = parseInt(meta.getAttribute('data-skipped'), 10) || skippedSoFar;
        catalogPage = parseInt(meta.getAttribute('data-catalog-next-page'), 10) || 2;
      }
      fetchCatalogChunk();
      return;
    }

    if (rendered === 0) {
      fetchCatalogChunk();
    }
  }

  function boot() {
    document.querySelectorAll('[data-only-one-left-page]').forEach(initPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-only-one-left-page]');
    if (root) initPage(root);
  });
})();
